import { toast } from "react-toastify";
import { AlertEventsApi } from "./api";
import AlertEventsTypes from "./types";
import IntlUtils from "services/intl/utils";

export class AlertEventsActioner {
  static setAlertEvents(data) {
    return {
      type: AlertEventsTypes.SET_ALERT_EVENTS,
      data,
    };
  }

  static setAlertEventsFilters = (key, value) => {
    return {
      type: AlertEventsTypes.SET_ALERT_EVENTS_FILTERS,
      key,
      value,
    };
  };

  static setAlertEventsPage = (page) => {
    return {
      type: AlertEventsTypes.SET_ALERT_EVENTS_PAGE,
      page,
    };
  };

  static setAlertEventsLimit = (limit) => {
    return {
      type: AlertEventsTypes.SET_ALERT_EVENTS_LIMIT,
      limit,
    };
  };

  static setAlertEventsInitialized = (initialized) => {
    return {
      type: AlertEventsTypes.SET_ALERT_EVENTS_INITIALIZED,
      initialized,
    };
  };

  static getAlertEvents = (page) => {
    return (dispatch, getState) => {
      const { contract } = getState().Contract;
      const { id } = contract;

      const pagination = getState().AlertFactory.alertEvents.pagination;
      if (page) {
        pagination.page = page;
      }

      const { from, to, rules, alert_policies, output_types } =
        getState().AlertFactory.alertEvents.filters ?? {};

      const filters = {
        contract_id: id,
        from: from.valueOf(),
        to: to.valueOf(),
        rules,
        alert_policies,
        types: output_types,
      };

      if (getState().AlertFactory.alertEvents.initialized) {
        dispatch(AlertEventsActioner.setAlertEventsInitialized(false));
      }

      return AlertEventsApi.getAlertEvents(pagination, filters)
        .then((res) => {
          dispatch(AlertEventsActioner.setAlertEvents(res));
        })
        .catch((error) => {
          const intl = IntlUtils.getIntlInstance();
          toast(intl.messages["toast.errors.errorOccuredContactSupport"], {
            position: toast.POSITION.BOTTOM_RIGHT,
            type: toast.TYPE.ERROR,
          });
          return Promise.reject(error);
        });
    };
  };

  static updateAlertEventsViewer = (alertEventIds) => {
    return (_, getState) => {
      const { contract } = getState().Contract;
      const { id } = contract;
      return AlertEventsApi.updateAlertEventsViewer({
        contract_id: id,
        event_ids: alertEventIds,
      });
    };
  };
}
